import Vue from 'vue'
import Vuex from 'vuex'

import account from '@/store/modules/account'
import patterns from './modules/patterns'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    account: account,
    patterns: patterns,
  }
})

export default store